var _a;
import { __decorate, __metadata } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetCurrentSpaceService } from '../domains/spaces/services/current-space-service.interface';
/**
 * Represents a service for retrieving selected space IDs.
 */
export const SelectedSpaceIdsService = Symbol('SelectedSpaceIdsService');
/**
 * Abstract base class for space action services.
 * Provides common functionality for registering commands and space actions.
 */
let AbstractSpaceActionService = class AbstractSpaceActionService {
};
__decorate([
    inject(GetCurrentSpaceService),
    __metadata("design:type", typeof (_a = typeof GetCurrentSpaceService !== "undefined" && GetCurrentSpaceService) === "function" ? _a : Object)
], AbstractSpaceActionService.prototype, "currentSpaceService", void 0);
__decorate([
    inject(SelectedSpaceIdsService),
    __metadata("design:type", Object)
], AbstractSpaceActionService.prototype, "selectedSpaceIdsService", void 0);
AbstractSpaceActionService = __decorate([
    injectable()
], AbstractSpaceActionService);
export { AbstractSpaceActionService };
